import { Copy, MailWarning } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/shared/ui/dialog.jsx";
import { Button } from "@/shared/ui/button.jsx";
import { Input } from "@/shared/ui/input.jsx";
import { Label } from "@/shared/ui/label.jsx";
import { toast } from "@/shared/ui/toaster.jsx";

/**
 * Mostra as credenciais quando o e-mail não pôde ser enviado.
 *
 * No app antigo, se o envio falhasse a conta ficava criada e ninguém
 * conhecia a senha — só restava criar outro usuário.
 *
 * @param {{ resultado: { user?: object, email?: string, password: string|null,
 *           emailError?: string|null } | null, onClose: () => void }} props
 */
export function CredentialsDialog({ resultado, onClose }) {
  const aberto = Boolean(resultado?.password);
  const email = resultado?.user?.email ?? resultado?.email ?? "";

  function copiar() {
    navigator.clipboard.writeText(`E-mail: ${email}\nSenha: ${resultado.password}`).then(
      () => toast.success("Credenciais copiadas."),
      () => toast.error("Não foi possível copiar."),
    );
  }

  return (
    <Dialog open={aberto} onOpenChange={(estado) => !estado && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MailWarning className="h-5 w-5 text-warning" />
            Repasse a senha manualmente
          </DialogTitle>
          <DialogDescription>
            {resultado?.emailError ??
              "O e-mail com as credenciais não pôde ser enviado."}{" "}
            Copie os dados abaixo — <strong>esta senha não será exibida de novo</strong>.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-2">
          <div className="space-y-2">
            <Label>E-mail</Label>
            <Input readOnly value={email} className="font-mono text-sm" />
          </div>
          <div className="space-y-2">
            <Label>Senha provisória</Label>
            <Input
              readOnly
              value={resultado?.password ?? ""}
              className="font-mono text-base font-semibold tracking-wide"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" className="gap-1.5" onClick={copiar}>
            <Copy className="h-4 w-4" />
            Copiar
          </Button>
          <Button onClick={onClose}>Entendi</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
